import { NameConvention } from '../types'

const countriesEasternNameConvention = new Set(['KOR', 'PRK', 'JPN', 'CHN', 'HKG', 'TPE'])

export const getNameConvention = (country: string|null): NameConvention => {
  if (country === null) return NameConvention.Western
  if (countriesEasternNameConvention.has(country)) return NameConvention.Eastern
  return NameConvention.Western
}
